import { render } from "./FairUpgrader.vue?vue&type=template&id=1b44cd46&scoped=true"
import script from "./FairUpgrader.vue?vue&type=script&lang=js"
export * from "./FairUpgrader.vue?vue&type=script&lang=js"

import "./FairUpgrader.vue?vue&type=style&index=0&id=1b44cd46&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b44cd46"]])

export default __exports__